import { ChangeDetectionStrategy, Component, computed, effect, inject, input, InputSignal, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { ITEM_DEFAULT } from './config/constants';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-stamp-map-markers',
    standalone: true,
    imports: [ 
        CommonModule, 
        GoogleMapsModule,
        TranslateModule
    ],
    templateUrl: './markers.component.html',
    styleUrl: './markers.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class StampMapMarkersComponent {
    @ViewChildren('markerRef', { read: MapMarker }) markersRef!: QueryList<MapMarker>;
    @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
    public translate = inject(TranslateService);

    private clusterer?: MarkerClusterer;
    private markerOptionsCache = new Map<number, google.maps.MarkerOptions>();
    public markers: InputSignal<any> = input.required<any>();
    public map: InputSignal<any> = input.required<any>();
    public mapClickEvent = input<google.maps.MapMouseEvent | null>(null);
    public selectedMarker: any;
    
    private readonly mapClickEffect = effect(() => {
        const lastClick = this.mapClickEvent();
        if (!lastClick || !this.infoWindow) return;
        this.onMapClick(lastClick);
    });

    async ngAfterViewInit(){
        const gmMarkers = await Promise.all(this.markersRef.map(m => m._resolveMarker()));
        this.clusterer = new MarkerClusterer({ 
            map: this.map(), 
            markers: gmMarkers, 
            algorithm: new SuperClusterAlgorithm({ maxZoom: 20, radius: 60 })
        });
    }

    public markerIcon(index: number): google.maps.MarkerOptions {
        if (!this.markerOptionsCache.has(index)) 
            this.markerOptionsCache.set(index, ITEM_DEFAULT(index + 1));
    
        return this.markerOptionsCache.get(index)!;
    }

    public getMarkerInfo(markerRef: MapMarker, marker: any) {
        this.selectedMarker = marker;
        this.infoWindow.open(markerRef);
    }

    public onImageError(event: Event) {
        (event.target as HTMLImageElement).src = '/assets/imgs/imageDefault.png';
    }

    ngOnDestroy(){
        this.clusterer.clearMarkers();
    }

    private onMapClick(_: google.maps.MapMouseEvent) {
        this.infoWindow.close();
        this.selectedMarker = null;
    }

}
